export enum ValueChainEditModalProps {
  LOADING_INDICATOR = 'Loading...',
  EMPTY_STRING = '',
  MODAL_WIDTH = 440,
}

export enum ButtonLabelsEditModal {
  EDIT = 'Edit',
  CANCEL = 'Cancel',
}

export enum ProcessingFacilityProps {
  SCOPE_1 = 'Scope 1',
  SCOPE_2 = 'Scope 2',
}
